import React from 'react';

import './styles.css';

import { Link } from 'react-router-dom';
import { FaUsersCog } from 'react-icons/fa';

import loadTextTest from '../../../../functions/loadTextTest';
import convertAgeGroud from '../../../../services/dataConverters/convertAgeGroud';

export default function ClassProfileCard(props) {
    return (
        <div className='class-page-card' id='card-profile'>
            <div className='class-card-profile-infos'>
                <h4><b>Turma {loadTextTest(props.classInfos.nome)}</b></h4>
                <p><b>{loadTextTest(props.classInfos.tipo)}</b></p>
                <p><b>Faixa etária: </b>{loadTextTest(props.classInfos.faixa_etaria ? convertAgeGroud(props.classInfos.faixa_etaria) : null)}</p>
            </div>
            {
                props.coachMode ?
                    [] :
                    <Link to={`./${props.classInfos.id}/editar`} className='button'>Editar turma<FaUsersCog /></Link>
            }
        </div>
    )
}